import { Suspense } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { routes } from '@/app/route-definitions'
import { FullscreenLoader } from '@/shared/ui/fullscreen-loader'
import i18n from '@/shared/i18n'

const router = createBrowserRouter(routes)

export function AppRouter() {
  return (
    <Suspense fallback={<FullscreenLoader message={i18n.t('app.loading_screen')} />}>
      <RouterProvider router={router} />
    </Suspense>
  )
}
